import React from 'react';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import Loader from '@amzn/meridian/loader';

export interface SiteLayoutHeaderProps {
  lastModifiedBy: string | null;
  lastModifiedAt: string | null;
  onSave: () => void;
  saveDisabled: boolean;
  saving: boolean;
}

const SiteLayoutHeader: React.FC<SiteLayoutHeaderProps> = ({
  lastModifiedBy,
  lastModifiedAt,
  onSave,
  saveDisabled,
  saving,
}) => {
  const formatDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? dateStr : date.toLocaleString();
  };

  return (
    <Row alignmentHorizontal="justify" alignmentVertical="center" spacing="400">
      <Row spacing="300">
        {lastModifiedBy && lastModifiedAt && (
          <Text type="b200" color="secondary">
            Last modified by {lastModifiedBy} on {formatDate(lastModifiedAt)}
          </Text>
        )}
      </Row>
      <Button
        type="primary"
        onClick={onSave}
        disabled={saveDisabled || saving}
        data-testid="save-site-layout-btn"
      >
        {saving ? <Loader size="small" /> : 'Save'}
      </Button>
    </Row>
  );
};

export default SiteLayoutHeader;
